import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function InitSuperAdmin() {
  const [nombre, setNombre] = useState('Super Admin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const res = await fetch(
        process.env.REACT_APP_API_URL + "/api/auth/init-super-admin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            nombre,
            email,
            password
          })
        }
      );

      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Error del servidor. Por favor, contacte al administrador.");
      }

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Error al crear Super Admin");
      }

      setSuccess("Super Admin creado exitosamente. Redirigiendo al login...");
      
      setTimeout(() => {
        navigate("/login");
      }, 2000);

    } catch (err) {
      console.error("Error:", err);
      setError(err.message || "Error de conexión con el servidor");
    }

    setLoading(false);
  };

  return (
    <div className="init-page">
      <div className="bg-svg" />
      <div className="overlay" />

      <div className="init-card">
        <div className="logo-wrapper">
          <img src="/logo-aileth.png" alt="Logo" />
        </div>

        <h2>Inicializar Sistema</h2>
        <p className="subtitle">Crear el primer Super Administrador</p>

        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <label>Nombre</label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Super Admin"
            required
          />

          <label>Correo electrónico</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@ejemplo.com"
            required
          />

          <label>Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          <button disabled={loading}>
            {loading ? 'Creando...' : 'Crear Super Admin'}
          </button>
        </form>

        <div className="footer-link">
          <a href="/login">¿Ya tienes cuenta? Inicia sesión</a>
        </div>
      </div>

      <style jsx>{`
        .init-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
        }

        .bg-svg {
          position: absolute;
          inset: 0;
          background-image: url('/fondo-web-aileth.png');
          background-size: cover;
          background-position: center;
          z-index: -2;
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.45);
          z-index: -1;
        }

        .init-card {
          width: 100%;
          max-width: 420px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(12px);
          padding: 2.5rem;
          border-radius: 14px;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.35);
        }

        .logo-wrapper {
          display: flex;
          justify-content: center;
          margin-bottom: 1.5rem;
        }

        .logo-wrapper img {
          max-width: 300px;
        }

        h2 {
          text-align: center;
          margin-bottom: 0.5rem;
          color: #2c3e50;
        }

        .subtitle {
          text-align: center;
          color: #7f8c8d;
          margin-bottom: 1.5rem;
          font-size: 0.9rem;
        }

        label {
          font-weight: 500;
          margin-top: 1rem;
          display: block;
          color: #34495e;
        }

        input {
          width: 100%;
          padding: 0.9rem;
          border-radius: 8px;
          border: 2px solid #ccc;
          margin-top: 0.4rem;
          font-size: 1rem;
        }

        input:focus {
          outline: none;
          border-color: #7e0ab4;
          box-shadow: 0 0 0 3px rgba(126, 10, 180, 0.15);
        }

        button {
          width: 100%;
          padding: 1rem;
          border-radius: 8px;
          border: none;
          background: #7e0ab4;
          color: #fff;
          font-weight: 600;
          font-size: 1.05rem;
          cursor: pointer;
          transition: 0.3s;
          margin-top: 1.5rem;
        }

        button:hover {
          background: #5e0785;
        }

        button:disabled {
          background: #aaa;
          cursor: not-allowed;
        }

        .error {
          background: rgba(231, 76, 60, 0.1);
          color: #e74c3c;
          padding: 0.75rem;
          border-radius: 6px;
          text-align: center;
          margin-bottom: 1rem;
        }

        .success {
          background: rgba(46, 204, 113, 0.1);
          color: #27ae60;
          padding: 0.75rem;
          border-radius: 6px;
          text-align: center;
          margin-bottom: 1rem;
        }

        .footer-link {
          text-align: center;
          margin-top: 1.5rem;
        }

        .footer-link a {
          color: #7e0ab4;
          text-decoration: none;
          font-size: 0.9rem;
        }

        .footer-link a:hover {
          text-decoration: underline;
        }

        @media (max-width: 480px) {
          .init-card {
            padding: 2rem;
          }

          .logo-wrapper img {
            max-width: 200px;
          }
        }
      `}</style>
    </div>
  );
}
